import { useSelector } from 'react-redux';

import { selectListsDetailPage } from 'app/containers/ListsPage/containers/ListsDetailPage/selectors';

export const useLoading = () => {
	const { isCityStateSearchOptionsLoading } = useSelector(selectListsDetailPage);

	return isCityStateSearchOptionsLoading;
};
